import { render, staticRenderFns } from "./CampaignSuppressionSkeleton.vue?vue&type=template&id=38b68b60&scoped=true&"
import script from "./CampaignSuppressionSkeleton.vue?vue&type=script&lang=js&"
export * from "./CampaignSuppressionSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSuppressionSkeleton.vue?vue&type=style&index=0&id=38b68b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b68b60",
  null
  
)

export default component.exports